/* Khatt By Randa - Website Revamp (Oct24)
 * Small "Added to cart" notice instead of opening the full cart drawer.
 * It watches the cart count on the header icon. When the count goes up and the
 * cart drawer is not already open, it shows a short notice with a "View cart" link.
 */
(function () {
  var toast = null;
  var hideTimer = null;
  var lastCount = null;

  function getCount() {
    var el = document.querySelector('#header-component [ref="cartBubbleCount"]');
    if (!el) return 0;
    var n = parseInt((el.textContent || '').trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  function drawerIsOpen() {
    var d = document.querySelector('#cart-drawer dialog');
    return !!(d && d.open);
  }

  function hide() {
    if (toast) toast.classList.remove('is-visible');
  }

  function build() {
    toast = document.createElement('div');
    toast.className = 'khatt-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<span class="khatt-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 16 16" width="14" height="14" fill="none"><path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '<span class="khatt-toast__text">Added to cart</span>' +
      '<button type="button" class="khatt-toast__btn">View cart</button>';
    toast.querySelector('.khatt-toast__btn').addEventListener('click', function () {
      hide();
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) {
        trigger.click();
      } else {
        window.location.href = '/cart';
      }
    });
    document.body.appendChild(toast);
  }

  function show() {
    if (!toast) build();
    // restart the slide-in if it is already showing
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, 3500);
  }

  function check() {
    var count = getCount();
    if (lastCount !== null && count > lastCount && !drawerIsOpen()) {
      show();
    }
    lastCount = count;
  }

  function init() {
    lastCount = getCount();
    var header = document.querySelector('#header-component') || document.body;
    new MutationObserver(check).observe(header, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
